import React from "react";
function Success({ action, message }) {
   
    return (
            <>
            <div className="success_mapper"></div>
            <div className="success">
                <div className="success_wrapper">
                    <h3 className="success_wrapper_heading">Success</h3>
                    <h4 className="success_wrapper_heading2">Set new password</h4>
                    <div className="success_wrapper_icon">
                        <svg id="icon-check1" height="70" width="70" viewBox="0 0 24 24">
                            
                        </svg>
                    </div>
                    <p className="success_wrapper_message">
                    { message}
                    </p>
                    <button onClick={action} className="success_wrapper_btn">
                        OK
                    </button>
                </div>
        </div>
        </>
    );
  }

  export default Success;
